export default "__VITE_ASSET__DUCVgDMm__"